<template>
  <transition name="fade">
    <component :is="currentComponent" />
  </transition>
</template>

<script>
import SubscriptionPlans from './SubscriptionPlans.vue';




export default {
  data() {
    return {
      currentComponent: this.decideComponent(),
    };
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler() {
        this.currentComponent = this.decideComponent();
      }
    }
  },
  methods: {
    decideComponent() {
        return SubscriptionPlans;
    }
  }
}
</script>

